<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs [(ttSelectedId)]="selectedBgEdiImportMain">
                <tt-tab ttId="DETAILS" ttLabel="gb_ediimport_main_details"></tt-tab>
                <tt-tab ttId="CONTENT" ttLabel="gb_ediimport_main_content"></tt-tab>
                <tt-tab ttId="FUNCTIONS" ttLabel="gb_ediimport_main_functions"></tt-tab>
            </tt-tabs>

            <div [hidden]="selectedBgEdiImportMain !== 'DETAILS'">
                <ng-container *ngTemplateOutlet="info"></ng-container>
                <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
            </div>

            <div [hidden]="selectedBgEdiImportMain !== 'CONTENT'">
                <tt-textarea ttLabel="filecontent" [(ttModel)]="edit.filecontent" ttRequired></tt-textarea>
                <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
            </div>

            <div [hidden]="selectedBgEdiImportMain !== 'FUNCTIONS'">
                <tt-button ttText="ediimport_process" (ttClick)="processChanges()" [ttSpin]="processing" ttIcon="fas fa-sync"></tt-button>
                <tt-button *ngIf="edit.edi_import_keyno !== '0'" ttText="ediimport_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
            </div>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="ediimport_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 sp-0" ttHeading="gb_ediimport_main_details">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 sp-0" ttHeading="gb_ediimport_main_content">
                        <tt-textarea ttLabel="filecontent" [(ttModel)]="edit.filecontent" ttRequired></tt-textarea>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40">
                    <tt-card class="col-xs-12 sp-0" ttHeading="gb_ediimport_main_functions">
                        <tt-button ttText="ediimport_process" (ttClick)="processChanges()" [ttSpin]="processing" ttIcon="fas fa-sync"></tt-button>
                        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
                        <tt-button *ngIf="edit.edi_import_keyno !== '0'" ttText="ediimport_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="edi_import_keyno" [ttModel]="edit.edi_import_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="reg_datetime" [ttModel]="edit.reg_datetime" ttReadonly></tt-input>
        <tt-select ttLabel="edi_source" [(ttModel)]="edit.edi_source_keyno" [ttData]="selectListEdiSources" ttDataId="item_id" ttDataName="item_name" ttRequired></tt-select>
        <tt-input ttLabel="filename" [(ttModel)]="edit.filename"></tt-input>
        <tt-input ttLabel="file_created_datetime" [ttModel]="edit.file_created_datetime" ttReadonly></tt-input>
        <tt-select ttLabel="p2_importproc" [(ttModel)]="edit.p2_importproc_keyno" [ttData]="selectListImportProcesses" ttDataId="item_id" ttDataName="item_name" ttRequired></tt-select>
        <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="edit.reg_by_portal_user_name" ttReadonly></tt-input>
        <tt-input ttLabel="prosessing_count" [ttModel]="edit.prosessing_count" ttReadonly></tt-input>
        <tt-input ttLabel="add_type" [ttModel]="edit.add_type" ttReadonly></tt-input>
        <tt-input ttLabel="edi_prosess_status_name" [ttModel]="edit.edi_prosess_status_name" ttReadonly></tt-input>
        <tt-input ttLabel="prosessing_start_datetime" [ttModel]="edit.prosessing_start_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="prosessing_end_datetime" [ttModel]="edit.prosessing_end_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="processing_millisec" [ttModel]="edit.processing_millisec" ttReadonly></tt-input>
        <tt-textarea ttLabel="prosessing_message" [ttModel]="edit.prosessing_message" ttReadonly></tt-textarea>
    </ng-container>
</ng-template>
